/**
 * 訃告內容（吳康民先生）
 *
 * 純文字資料，不涉及任何 JSX，方便日後改字。
 * 顯示與否由 src/layoutPages/mourningMode.ts 的 MOURNING_MODE 控制。
 */

export interface NoticeParagraph {
    /** 段落文字；以 indented 開頭的段落會顯示為縮排的引言段落 */
    text: string;
    indented?: boolean;
}

export const ObituaryNotice = {
    title: "訃告",
    /** 主辦機構（顯示於最後署名欄） */
    organization: "培僑教育機構",

    /** 署名前的結語 */
    closing: "哲人其萎，範垂後世，培僑同仁深切哀悼，永懷不忘。",

    paragraphs: [
        { text: "培僑教育機構謹以無比悲痛的心情公告：" },
        {
            text: "本機構榮譽主席、培僑中學前校長、香港教育工作者聯會創會會長、香港著名愛國教育家與社會活動家吳康民大紫荊勳賢，歷任第四至第十屆全國人大代表、香港地區全國人大代表團團長、香港特別行政區籌備委員會委員、全國人大常委會香港基本法委員會委員，於二〇二六年十月十八日上午，在家人陪伴下安詳辭世，享壽百歲。",
            indented: true,
        },
        { text: "吳康民先生畢生心繫國家、立足香港，為香江愛國教育事業之基石與先驅。先生一九四七年畢業於中山大學，隨即來港投身培僑中學任教，自此奉獻畢生心血於培僑。先生由風華正茂之青年教師，歷任校長、校監以至董事會主席，執掌校政二十八載，數十年間胼手胝足、砥礪校務、興辦實學，將培僑由傳統愛國學校，發展為涵蓋中學、小學、書院及幼稚園之多元化優質教育機構。先生功德卓著，基業長青，誠如參天大樹，「德昭黌宇，功蔭培僑」，恩澤一代代培僑師生與校友，為培僑教育體系之蓬勃發展奠定極其深厚之基石。" },
        { text: "先生一生愛國愛港，襟懷磊落，以教育為本，致力弘揚家國情懷，積極促進內地與香港交流，竭力維護香港繁榮穩定；晚年依然筆耕不輟，以坦蕩襟懷與獨到見解言政論政，深受社會各界敬重。百歲歲月，風骨昭然，其辦學理念、崇高品德與愛國精神，早已化作培僑之精神基因，為培僑體系全體師生、校友及香港教育界永遠之典範。" },
    ],

    /** 治喪安排的獨立段落 */
    arrangements: "培僑教育機構將成立治喪委員會，治喪各項安排容後另行公布。",

    farewell: "謹此訃聞。",

    signOff: "培僑教育機構 謹啟",
    date: "二〇二六年十月十八日",
};
